import { inject, Pipe, type PipeTransform } from "@angular/core";
import { Store } from "@viewer/core";

@Pipe({
  name: "getDUUrl",
  standalone: true
})
export class GetDUUrlPipe implements PipeTransform {
  private readonly store = inject(Store);

  private readonly baseUrl = `/pub/${this.store.publicationID}/${this.store.publicationRevision}/du`;

  public transform(dmc: string, dmcSelected?: string): string {
    if (!dmc || dmc === dmcSelected) {
      return undefined;
    }
    return `${this.baseUrl}/${dmc}`;
  }
}
